import React from 'react';
import { AboutRulesWrap, PlateSubTitle, PlateTitle, Ul } from './styled';
import { H5, Space, Text } from '@gr-monorepo/common/ui';
import { Section } from '@gr-monorepo/common/models/gratitude';
import { ReactComponent as GratitudesPicture } from './gratitudes.svg';
import { BlueLink } from 'features/shared/ui/Button';

export const GratitudesPlateTemplate = (props: React.PropsWithChildren<{ title?: string; subtitle?: string }>) => {
  return (
    <>
      {!!props.title && (
        <>
          <PlateTitle>{props.title}</PlateTitle>
          <Space size={props.subtitle ? 8 : 36} axis="vertical" />
        </>
      )}
      {props.subtitle ? (
        <>
          <PlateSubTitle>{props.subtitle}</PlateSubTitle>
          <Space size={36} axis="vertical" />
        </>
      ) : null}
      {props.children}
    </>
  );
};
const AboutRules = () => (
  <AboutRulesWrap>
    <div>
      <H5 Grey style={{ textTransform: 'uppercase', fontWeight: 'bold' }}>
        Учитываются следующие показатели:
      </H5>
      <Space axis="vertical" size={16} />

      <Text style={{ fontWeight: 'bold' }}>Олимпиады</Text>
      <Space axis="vertical" size={2} />
      <Ul>
        <li>Сколько учеников приняли участие </li>
        <li>Как изменилось количество участников с прошлого года</li>
        <li>Сколько учеников зарегистрировано на платформе </li>
      </Ul>
      <Space axis="vertical" size={8} />
      <Text style={{ fontWeight: 'bold' }}>Вебинары</Text>
      <Space axis="vertical" size={2} />
      <Ul>
        <li>Как изменилось количество участников с прошлого года</li>
        <li>Сколько вебинаров посмотрели учителя</li>
      </Ul>
    </div>
    <GratitudesPicture style={{ marginRight: 80 }} />
  </AboutRulesWrap>
);
export const GratitudesPlateSchool = (
  props: React.PropsWithChildren<{ isEmpty: boolean; loading: boolean; isMunicipality: boolean }>,
) => (
  <>
    <PlateTitle>Школы</PlateTitle>
    <Space size={8} axis="vertical" />
    <PlateSubTitle>
      {!props.loading && (
        <>
          {props.isEmpty ? (
            <>
              Учебные заведения могут получать благодарственные письма за активное участие
              <br /> в олимпиадах и вебинарах Учи.ру.
            </>
          ) : (
            <>
              Благодарственные письма за активное участие в олимпиадах и вебинарах Учи.ру. <br />
              Отправьте документы школам с помощью{' '}
              <BlueLink
                download
                target="_blank"
                href={'https://upr.uchi.ru/files/c5c837f575bf801f/Как скачать благодарственные письма.pdf'}
              >
                памятки
              </BlueLink>
              .
            </>
          )}
        </>
      )}
    </PlateSubTitle>
    <Space size={24} axis="vertical" />
    {props.children}
    {props.isMunicipality && <AboutRules />}
  </>
);

export const GratitudesPlateMain = (props: React.PropsWithChildren<{ isEmpty: boolean }>) => (
  <GratitudesPlateTemplate
    title={'Регион и муниципалитет'}
    subtitle="Благодарственные письма за помощь в развитии цифрового образования в России."
  >
    {props.children}
  </GratitudesPlateTemplate>
);

export const sections = {
  [Section.municipality]: GratitudesPlateMain,
  [Section.school]: GratitudesPlateSchool,
};
